// src/api/AcademicBase/PreschoolPerformancesService.ts
import client from "../Client/HttpClient";
import { IPreschoolPerformancesModel } from "@/interfaces/modules";

const ApiPath = "PreschoolPerformances";

export default {
    GetPreschoolPerformances: (): Promise<IPreschoolPerformancesModel[]> => client.get(`${ApiPath}`),
    GetPreschoolPerformanceById: (data: { Id: number }): Promise<IPreschoolPerformancesModel> => client.get(`${ApiPath}/${data.Id}`),
    PostPreschoolPerformance: (data: IPreschoolPerformancesModel): Promise<IPreschoolPerformancesModel> => client.post(`${ApiPath}`, data)
};
